module.exports = require('./helpers/bundle-url').getBundleURL('9pgM9') + "passing-routes-blue.2146ac26.svg" + "?" + Date.now();